export enum RoleDropdownOptions {
  Admin = 'Admin',
  Operator = 'Operator'
}

export enum UserRoles {
  Admin = 'admin',
  Operator = 'user'
}

export enum AuthTypes {
  Local = 'local',
  Ldap = 'ldap',
  Keycloak = 'keycloak'
}
